<template>
  <div style='height: 95%'>
    <!-- //卡片视图区域 -->
    <el-card>
      <!-- 图片列表区域 -->
      <el-table :data='picturelist' border stripe>
        <el-table-column type='index'></el-table-column>
        <el-table-column label='图片' prop='name'>
          <template slot-scope='scope'>
            <img :src='scope.row.url' width='300' height='150' class='head_pic'/>
          </template>
        </el-table-column>
        <el-table-column label='操作'>
          <template slot-scope='scope'>
            <!-- 修改按钮 -->
            <el-button
                  type='primary'
                  icon='el-icon-edit'
                  size='mini'
                  @click='showEditDialog(scope.row.id), (editDialogVisible = true)'
                >
            </el-button>
            <!-- 删除按钮 -->
            <el-button
                  type='danger'
                  icon='el-icon-delete'
                  size='mini'
                  @click='removePictureById(scope.row.id)'
                >
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- <div
        v-for='(item, index) in picturelist'
        :key='index'
        class='img'
        :class='pic[index]'
        @click='showEditDialog(item.id), (editDialogVisible = true)'
      >
        <img :src='item.name' title='点击更换图片' />
      </div> -->
    </el-card>

    <!-- 更换图片的对话框 -->
    <el-dialog
      title='更换轮播图'
      :visible.sync='editDialogVisible'
      width='50%'
      @close='editDialogClosed'
    >
      <el-form :model='editForm' ref='editFormRef'>
        <el-form-item label='更换图片：' prop='name'>
          <el-upload
            drag
            ref='upload'
            action='none'
            accept='.jpg,.jepg,.png,.JPG,.JEPG,.PNG'
            :limit='1'
            :auto-upload='false'
            :on-change='onChange'
          >
            <i class='el-icon-upload'></i>
            <div class='el-upload__text'>
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
          <el-dialog :visible.sync='dialogVisible'>
            <img width='100%' :src='dialogImageUrl' alt='' />
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot='footer' class='dialog-footer'
        ><el-button type='primary' @click='editPictureInfo'>确 定</el-button>
        <el-button @click='editDialogVisible = false'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 图片列表
      picturelist: [
        {
          id: '',
          name: ''
        }
      ],
      // 控制修改图片对话框的显示
      editDialogVisible: false,
      // 查询到的图片信息对象
      editForm: {
        id: '',
        name: ''
      },
      // 上传文件
      updateFile: null,
      // 图片上传
      dialogImageUrl: '',
      dialogVisible: false,
      pic: ['p1', 'p2', 'p3', 'p4']
    }
  },
  created () {
    this.getPictureList()
  },
  methods: {
    onChange (file) {
      this.updateFile = file
      // 把图片转成base64编码
      // const a = new FileReader()
      // a.readAsDataURL(file.raw)
      // a.onload = (e) => {
      //   this.editForm.name = e.target.result
      // }
      console.log('onChange.updateFile.name========' + this.updateFile.name)
    },
    async getPictureList () {
      const { data: res } = await this.$http.post('/picture/selectList', {type: 2})
      if (res.code !== 1) {
        return this.$message.error('获取图片列表失败！')
      }
      this.picturelist = res.body
    },
    // 展示编辑图片的对话框
    async showEditDialog (id) {
      const { data: res } = await this.$http.post('/picture/selectOne', { id: id })
      if (res.code !== 1) {
        return this.$message.error('查询图片失败!')
      }
      console.log('selectOne.res========' + JSON.stringify(res))
      this.editForm = res.body
      this.editDialogVisible = true
    },
    // 监听修改图片对话框的关闭事件
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },
    // 修改图片并提交
    editPictureInfo () {
      console.log('config.updateFile========' + this.updateFile)
      const fd = new FormData()
      fd.append('file', this.updateFile.raw)
      fd.append('data', JSON.stringify({type: 2, id: this.editForm.id}))

      // 发起修改信息的数据请求
      this.$http.post('/picture/upload', fd, {
        'Content-Type': 'multipart/form-data;charset=utf-8', 'Accept': '*/*'
      }).then(res => {
        console.log('res.data========' + JSON.stringify(res.data))
        if (res.data.code !== 1) {
          return this.$message.error('更新图片失败！')
        }
        // 关闭对话框
        this.editDialogVisible = false
        // 清空图片
        this.$refs.upload.clearFiles()
        // 刷新数据列表
        this.getPictureList()
        // 提示修改成功
        this.$message.success('更新图片成功！')
      }).catch(err => {
        console.log('err========' + err)
      })
    },
    // 根据id删除图片
    async removePictureById (id) {
      // 弹窗询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该图片闻, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      // 如果用户确认删除，则返回值为字符串confirm
      // 如果用户了取消了删除，则返回值为字符串 cancel
      // 所以可以考返回值判断用户是否删除
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post(
        '/picture/delete', { id: id }
      )
      if (res.code !== 1) {
        return this.$message.error('删除新闻失败')
      }
      this.$message.success('删除新闻成功')
      this.getPictureList()
    },
    // 上传图片监听事件
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang='less'>
.el-card {
  position: relative;
  margin-bottom: 8px;
  height: 100%;
  .p1 {
    position: absolute;
    top: 40px;
    left: 300px;
    height: 350px;
    width: 500px;
    border: 1px solid black;
  }
  .p2 {
    position: absolute;
    top: 40px;
    left: 850px;
    height: 350px;
    width: 500px;
    border: 1px solid black;
  }
  .p3 {
    position: absolute;
    top: 432px;
    left: 300px;
    height: 350px;
    width: 500px;
    border: 1px solid black;
  }
  .p4 {
    position: absolute;
    top: 432px;
    left: 850px;
    height: 350px;
    width: 500px;
    border: 1px solid black;
  }
  .img:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/editpicture2.vue